// (function () {
//     const intervalId = setInterval(() => {
//         if (window.tlDiscountCode) {
//             clearInterval(intervalId);

//             var INPUT_SELECTOR = '.docapp-coupon-input--input';
//             var BUTTON_SELECTOR = '.docapp-coupon-input--button';
//             var MAX_WAIT_MS = 6000;
//             var POLL_INTERVAL_MS = 400;

//             function fetchCart() {
//                 return fetch('/cart.js').then(function (res) { return res.json(); });
//             }

//             function snapshotOf(cart) {
//                 return (cart.discount_codes || [])
//                     .filter(function (d) { return d.applicable; })
//                     .map(function (d) { return d.code; })
//                     .sort()
//                     .join('|');
//             }

//             async function syncSalepifyGifts() {
//                 if (!window.tlDiscountCode) return;
//                 await window.tlDiscountCode.getGiftAdded();
//                 await window.tlDiscountCode.reAutoAdd();
//                 window.tlDiscountCode.renderCodeApplied();
//                 window.tlDiscountCode.reRenderGiftSelector();
//             }

//             async function waitCartChangeAndSync(beforeSnapshot) {
//                 var elapsed = 0;
//                 while (elapsed < MAX_WAIT_MS) {
//                     await new Promise(function (r) { setTimeout(r, POLL_INTERVAL_MS); });
//                     elapsed += POLL_INTERVAL_MS;
//                     var cart = await fetchCart();
//                     if (snapshotOf(cart) !== beforeSnapshot) {
//                         await syncSalepifyGifts();
//                         return;
//                     }
//                 }
//             }

//             async function onApplyTriggered() {
//                 var cart = await fetchCart();
//                 waitCartChangeAndSync(snapshotOf(cart));
//             }

//             document.addEventListener('DOMContentLoaded', function () {
//                 var input = document.querySelector(INPUT_SELECTOR);
//                 var button = document.querySelector(BUTTON_SELECTOR);

//                 if (button) {
//                     button.addEventListener('click', onApplyTriggered, true);
//                 }
//                 if (input) {
//                     input.addEventListener('keydown', function (e) {
//                         if (e.key === 'Enter') onApplyTriggered();
//                     }, true);
//                 }
//             });
//         }
//     }, 50);
//     setTimeout(() => clearInterval(intervalId), 3000);
// })();

(function () {
    const intervalId = setInterval(() => {
        if (window.tlDiscountCode) {
            clearInterval(intervalId);

            var INPUT_SELECTOR = '.docapp-coupon-input--input';
            var BUTTON_SELECTOR = '.docapp-coupon-input--button';
            var MAX_WAIT_MS = 6000;
            var POLL_INTERVAL_MS = 400;
            var MANUAL_GIFT_ADD_TYPE = 'manual_add';

            var isSyncing = false;

            function fetchCart() {
                return fetch('/cart.js').then(function (res) { return res.json(); });
            }

            function snapshotOf(cart) {
                return (cart.discount_codes || [])
                    .filter(function (d) { return d.applicable; })
                    .map(function (d) { return d.code; })
                    .sort()
                    .join('|');
            }

            async function healMissingGiftDiscounts() {
                var tl = window.tlDiscountCode;
                if (!tl || !tl.ruleIdMapData || !tl.ruleIdApplied) {
                    console.log('[tl-heal] skip: tlDiscountCode not ready', tl);
                    return;
                }

                var cart = await fetchCart();
                var applicableCodes = (cart.discount_codes || [])
                    .filter(function (d) { return d.applicable; })
                    .map(function (d) { return d.code; });
                var applicableSet = new Set(applicableCodes);

                console.log('[tl-heal] ruleIdApplied:', tl.ruleIdApplied);
                console.log('[tl-heal] applicable discount codes in cart:', applicableCodes);

                var missingRuleNames = [];
                (tl.ruleIdApplied || []).forEach(function (ruleId) {
                    var rule = tl.ruleIdMapData.get(ruleId);
                    console.log('[tl-heal] ruleId', ruleId, '-> rule found?', !!rule, rule);
                    if (!rule) return;
                    if (rule.gift_add_type === MANUAL_GIFT_ADD_TYPE) {
                        console.log('[tl-heal] ruleId', ruleId, 'is manual_add, skipping heal check');
                        return;
                    }
                    if (rule.name && !applicableSet.has(rule.name)) {
                        console.log('[tl-heal] MISSING discount for ruleId', ruleId, '-> rule.name =', rule.name);
                        missingRuleNames.push(rule.name);
                    }
                });

                if (!missingRuleNames.length) {
                    console.log('[tl-heal] nothing missing, no action taken');
                    return;
                }

                var allCodes = Array.from(new Set(applicableCodes.concat(missingRuleNames))).slice(0, 5);
                console.log('[tl-heal] re-applying discount list:', allCodes);

                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ discount: allCodes.join(',') })
                });

                await syncSalepifyGifts(false);
                console.log('[tl-heal] done');
            }
            // Expose for manual testing from the console: window.__tlHealMissingGiftDiscounts()
            window.__tlHealMissingGiftDiscounts = healMissingGiftDiscounts;

            async function syncSalepifyGifts(runHealCheck) {
                if (!window.tlDiscountCode) return;
                await window.tlDiscountCode.getGiftAdded();
                await window.tlDiscountCode.reAutoAdd();
                window.tlDiscountCode.renderCodeApplied();
                window.tlDiscountCode.reRenderGiftSelector();

                if (runHealCheck !== false) {
                    await healMissingGiftDiscounts();
                }
            }

            async function waitCartChangeAndSync(beforeSnapshot) {
                var elapsed = 0;
                try {
                    while (elapsed < MAX_WAIT_MS) {
                        await new Promise(function (r) { setTimeout(r, POLL_INTERVAL_MS); });
                        elapsed += POLL_INTERVAL_MS;
                        var cart = await fetchCart();
                        if (snapshotOf(cart) !== beforeSnapshot) {
                            await syncSalepifyGifts();
                            return;
                        }
                    }
                } finally {
                    isSyncing = false;
                }
            }

            async function onApplyTriggered() {
                if (isSyncing) return;
                isSyncing = true;
                var cart = await fetchCart();
                waitCartChangeAndSync(snapshotOf(cart));
            }

            document.addEventListener('DOMContentLoaded', function () {
                var input = document.querySelector(INPUT_SELECTOR);
                var button = document.querySelector(BUTTON_SELECTOR);

                if (button) {
                    button.addEventListener('click', onApplyTriggered, true);
                }
                if (input) {
                    input.addEventListener('keydown', function (e) {
                        if (e.key === 'Enter') onApplyTriggered();
                    }, true);
                }
            });

            setTimeout(healMissingGiftDiscounts, 2500);
        }
    }, 50);
    setTimeout(() => clearInterval(intervalId), 3000);
})();
